<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showMultaGlobal"
      scrollable
      no-close-on-backdrop
      title="Multa Global"
      cancel-variant="outline-secondary"
      @hidden="close"
    >
      <b-row>
        <b-col md="7">
          <b-form-textarea
            id="textarea-default"
            placeholder="Concepto"
            rows="3"
            size="sm"
            v-model="concepto"
          />
        </b-col>
        <b-col md="3">
          <b-row>
            <b-col md="12">
              <b-form-spinbutton
                id="sb-maxmin"
                v-model="cantidad"
                placeholder="Cant"
                size="sm"
                min="0"
                @input="calculaSubtotal"
              />
            </b-col>
            <b-col md="12" class="mt-2 d-flex justify-content-center">
              <b-badge
                variant="warning"
                style="background-color:#d2d2d2; font-size:15px"
              >
                Total: {{ valorTotal }} $
              </b-badge>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row>
            <b-col md="12" class="p-0">
              <b-form-input
                placeholder="V.Unitario"
                size="sm"
                type="number"
                v-model="valorUnitario"
                @input="calculaSubtotal"
                class="m-0"
              />
            </b-col>
            <!-- <b-col md="12" class="mt-2 d-flex justify-content-center">
              <b-button
                v-if="!showLoading"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="primary"
                size="sm"
                @click="insertMultaIndividual"
              >
                <span class="align-middle">Guardar</span>
              </b-button>
              <div v-if="showLoading" class="text-center ">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
      <div
        v-if="messageError != ''"
        style="position:absolute; width:80%; text-align:center"
      >
        <span style="font-size:12px; color:red">{{ messageError }}</span>
      </div>
      <br />
      <div class="form-label-group  mt-1">
        <b-form-input
          placeholder="Ingrese #cuotas"
          size="sm"
          type="number"
          v-model="numCuotas"
        />
        <label for="floating-label1"> # Cuotas</label>
      </div>
      <span v-if="numCuotas !== 0 && numCuotas !== null && numCuotas !== ''"
        >Se dividira en {{ numCuotas }} cuotas de {{ totalCadaCuota }} $</span
      >
      <div
        cols="12"
        md="3"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <!-- {{ listCategoriasAdmin }} -->
        <v-select
          placeholder="Seleccione Categoria"
          :options="listCategoriasAdmin"
          :clearable="false"
          style="width: 100%"
          v-model="categoriaAdmin"
        />
      </div>

      <div style="margin-top:20px ;">
        Seleccione los equipos a los que se agregara la multa
      </div>
      <div style="height: 40vh; overflow: auto;">
        <!-- <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="equiposSelected"
          :options="listEquipos"
          name="flavour-1"
          sty
        >
        </b-form-checkbox-group> -->
        <b-form-checkbox
          v-for="option in listEquipos"
          :key="option.value"
          v-model="equiposSelected"
          :value="option.value"
          name="flavour-3a"
          style="margin: 10px;"
        >
          {{ option.text }}
        </b-form-checkbox>
      </div>
      <template #modal-footer>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-primary"
          class="float-right mr-1"
          @click="close"
        >
          Cancelar
        </b-button>
        <b-button
          v-if="!showLoading"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right"
          @click="insertMultaIndividual"
        >
          Guardar
        </b-button>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BFormInput,
  BBadge,
  BButton,
  BFormTextarea,
  BFormSpinbutton,
  BSpinner,
  BFormCheckbox,
  // BFormCheckboxGroup,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  URL,
  USER,
  //   ROLES,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSpinbutton,
    BSpinner,
    vSelect,
    BFormCheckbox,
    // BFormCheckboxGroup,
  },
  props: {
    listCategoriasAdmin: Array,
    campeonato: Object,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    const cantidad = ref(null)
    const valorUnitario = ref(null)
    const valorTotal = ref(0.0)
    const concepto = ref(null)
    const showLoading = ref(false)
    const messageError = ref(null)
    const numCuotas = ref(null)
    const { postApi } = apiCall()
    const categoriaAdmin = ref(null)
    const equiposSelected = ref([])
    const totalCadaCuota = computed(
      () =>
        // eslint-disable-next-line
        (valorTotal.value / numCuotas.value).toFixed(2)
      // eslint-disable-next-line
    )
    const listEquipos = computed(() => {
      const arraySalida = []
      // console.log(categoriaAdmin)
      if (categoriaAdmin.value != null) {
        categoriaAdmin.value.equipos.forEach(element => {
          const obj = {
            text: `${element.apodo} ${element.alias_equipo}`,
            value: element.id_equipo,
          }
          arraySalida.push(obj)
        })
        // console.log(arraySalida)
      }
      return arraySalida
    })
    function calculaSubtotal() {
      if (cantidad.value !== null && valorUnitario.value !== null) {
        valorTotal.value = (cantidad.value * valorUnitario.value).toFixed(2)
      }
    }
    function hasErrorForm() {
      // console.log(concepto.value)
      let error = false
      if (
        concepto.value === undefined ||
        concepto.value === null ||
        concepto.value === ''
      ) {
        error = true
        messageError.value = 'Concepto no debe ser vacio'
      } else if (
        cantidad.value === undefined ||
        cantidad.value === null ||
        cantidad.value === 0
      ) {
        error = true
        messageError.value = 'La cantidad ingresada es incorrecta'
      } else if (
        valorUnitario.value === null ||
        valorUnitario.value === undefined ||
        Number(valorUnitario.value) <= 0 ||
        valorUnitario.value === ''
      ) {
        error = true
        messageError.value = 'valor unitario no válido'
      } else {
        error = false
        messageError.value = ''
      }
      return error
    }
    function resetValores() {
      messageError.value = ''
      concepto.value = null
      cantidad.value = null
      valorUnitario.value = null
      valorTotal.value = null
      showLoading.value = false
      numCuotas.value = null
      equiposSelected.value = []
    }
    function close() {
      resetValores()
      store.commit('someVariables/UPDATE_SHOW_MULTA_GLOBAL', false)
    }
    async function insertMultaIndividual() {
      valorTotal.value = cantidad.value * valorUnitario.value
      const data = {
        vUnitario: valorUnitario.value,
        vTotal: valorTotal.value,
        cantidad: cantidad.value,
        concepto: concepto.value,
        numCuotas: numCuotas.value,
        valorCuotas: totalCadaCuota.value,
        equipos: equiposSelected.value,
        idCampeonato: props.campeonato.value,
      }
      const hasError = hasErrorForm()
      if (!hasError) {
        showLoading.value = true
        const path = 'ApiMultas/insertMultaGlobal'
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          equiposSelected.value = []
          showLoading.value = false
          // store.commit('someVariables/UPDATE_SHOW_MULTA_GLOBAL', false)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'GUARDADO con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          })
          emit('multaGlobalCreada')
          // resetValores()
        }
        // showLoading.value = false
      }
    }
    return {
      calculaSubtotal,
      insertMultaIndividual,
      concepto,
      cantidad,
      valorUnitario,
      showLoading,
      valorTotal,
      messageError,
      numCuotas,
      totalCadaCuota,
      resetValores,
      close,
      categoriaAdmin,
      USER,
      listEquipos,
      equiposSelected,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
